const featureFlags = {
  hideArticleBodyHyperlinks: 'hideArticleBodyHyperlinks',
};

// Module Exports
export { featureFlags };
